import type React from 'react';

// スタンプ用SVG定義
export const stampSvgs: Record<string, (color: string) => React.ReactNode> = {
  star: (color) => (
    <svg aria-hidden="true" viewBox="0 0 24 24" fill={color} className="w-full h-full">
      <path d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.787 1.4 8.168L12 18.896l-7.334 3.857 1.4-8.168L.132 9.21l8.2-1.192L12 .587z" />
    </svg>
  ),
  heart: (color) => (
    <svg aria-hidden="true" viewBox="0 0 24 24" fill={color} className="w-full h-full">
      <path d="M12 4.419C12 4.419 10.082 1.25 6.5 1.25 3.125 1.25.5 3.875.5 7.25c0 5.42 6.643 9.458 11.5 14.25 4.857-4.792 11.5-8.83 11.5-14.25 0-3.375-2.625-6-6-6-3.582 0-5.5 3.169-5.5 3.169z" />
    </svg>
  ),
  cat: (color) => (
    <svg aria-hidden="true" viewBox="0 0 24 24" fill={color} className="w-full h-full">
      <path d="M11.5 2c-.8 0-1.5.5-1.8 1.2L7.9 7.5H6c-1.1 0-2 1.1-2 2.5v6.5C4 18.1 5.3 19.5 7 19.5h10c1.7 0 3-1.4 3-3V10c0-1.4-1-2.5-2-2.5h-1.9l-1.8-4.3c-.3-.7-1-1.2-1.8-1.2z M15.5 11c.8 0 1.5.7 1.5 1.5S16.3 14 15.5 14S14 13.3 14 12.5s.7-1.5 1.5-1.5zm-7 0c.8 0 1.5.7 1.5 1.5S9.3 14 8.5 14S7 13.3 7 12.5s.7-1.5 1.5-1.5zm3.5 4.5c.8 0 1.5.7 1.5 1.5S12.8 18.5 12 18.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5z" />
    </svg>
  ),
  cherry: (color) => (
    <svg aria-hidden="true" viewBox="0 0 24 24" fill={color} className="w-full h-full">
      {/* 単一の花びらから、美しい5枚花びらの完全な桜の花に刷新 */}
      <path d="M12 2.7c-.3 0-.6.1-.8.3C10.5 3.7 10 5.4 10 7c0 .7.1 1.4.3 2-.9-.7-2-.9-3-.9-1.5 0-3.1.5-3.8 1.9-.2.3-.3.6-.3.8 0 .3.1.6.3.8.7 1.3 2.3 1.8 3.8 1.8 1 0 2.1-.2 3-.9-.2.6-.3 1.3-.3 2 0 1.6.5 3.3 1.2 4 .2.2.5.3.8.3.3 0 .6-.1.8-.3.7-.7 1.2-2.4 1.2-4 0-.7-.1-1.4-.3-2 .9.7 2 .9 3 .9 1.5 0 3.1-.5 3.8-1.9.2-.3.3-.6.3-.8 0-.3-.1-.6-.3-.8-.7-1.3-2.3-1.8-3.8-1.8-1 0-2.1.2-3 .9.2-.6.3-1.3.3-2 0-1.6-.5-3.3-1.2-4-.2-.2-.5-.3-.8-.3z M12 10.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5z" />
    </svg>
  ),
  snow: (color) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      className="w-full h-full"
    >
      <path d="M12 2v20M2 12h20M5 5l14 14M19 5L5 19M12 5l3 3M12 19l-3-3M5 12l3 3M19 12l-3-3" />
    </svg>
  ),
  moon: (color) => (
    <svg aria-hidden="true" viewBox="0 0 24 24" fill={color} className="w-full h-full">
      <path
        d="M21.75 15c-.13 0-.26-.01-.39-.03a9.76 9.76 0 0 1-8.19-8.19A.49.49 0 0 0 12.5 6.5c-.26 0-.5.18-.53.44a10.01 10.01 0 0 0 11.22 11.22c.26-.03.44-.27.44-.53a.5.5 0 0 0-.38-.63z"
        transform="rotate(-20 12 12)"
      />
    </svg>
  ),
  crest: (color) => (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
      className="w-full h-full"
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="8" strokeDasharray="3 2" />
      <polygon points="12,3 19.8,16.5 4.2,16.5" />
      <polygon points="12,21 4.2,7.5 19.8,7.5" />
    </svg>
  ),
  rose: (color) => (
    <svg aria-hidden="true" viewBox="0 0 24 24" fill={color} className="w-full h-full">
      <path d="M12 2C8.69 2 6 4.69 6 8c0 .87.19 1.7.53 2.45L4.1 12.87c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l2.31-2.31C8.75 12.57 9.84 13 11 13c3.31 0 6-2.69 6-6V5c0-1.66-1.34-3-3-3h-2zm0 2c1.1 0 2 .9 2 2v1c0 1.1-.9 2-2 2s-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    </svg>
  ),
  gear: (color) => (
    <svg aria-hidden="true" viewBox="0 0 24 24" fill={color} className="w-full h-full">
      <path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" />
    </svg>
  ),
  ink: (color) => (
    <svg aria-hidden="true" viewBox="0 0 24 24" fill={color} className="w-full h-full">
      <path d="M12 2C7 2 4 6 4 9c0 1.25.5 2.5 1.5 3.5C6 13 8 13.5 9 14.5c1 1 1 2 2 3 .5.5 1 .5 1.5.5s1 0 1.5-.5c1-1 1-2 2-3 .9-1 2.9-1.5 3.5-2 .9-1 1.5-2.25 1.5-3.5 0-3-3-7-8-7z" />
    </svg>
  ),
};
